<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
                    [(ngModel)]="SchoolID"
                    (ngModelChange)="onSchoolChange($event)">
                    <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
                </select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>

		<div class="selector-item">
			<div>
				<label>Start Date</label>
			</div>

			<div style="margin-left: 10px">
				<p-calendar
					[disabled]="loading"
					[(ngModel)]="StartDT"
					(ngModelChange)="onStartDateChange($event)"
					showIcon="true"
					showButtonBar="true"
				></p-calendar>
			</div>
		</div>

		<div class="selector-item">
			<div>
				<label>End Date</label>
			</div>

			<div style="margin-left: 10px">
				<p-calendar
					[disabled]="loading"
					[(ngModel)]="EndDT"
					(ngModelChange)="onEndDateChange($event)"
					showIcon="true"
					showButtonBar="true"
				></p-calendar>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddIncident()">Add Incident</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditIncident()">Edit Incident</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteIncident()">Delete Incident</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchoolIncident"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchoolIncident"
		dataKey="SchoolIncidentID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--IncidentDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="IncidentDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SchoolIncidentTypeDesc-->
				<th>
					<p-columnFilter field="SchoolIncidentTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolIncidentTypeDesc
								[ngModel]="value"
								[options]="lstSchoolIncidentTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Comment-->
				<th>
					<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AdminName-->
				<th>
					<p-columnFilter type="text" field="AdminName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<!-- <th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterActiveDesc [ngModel]="value" [options]="lstActiveDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th> -->
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="IncidentDT">Date/Time<p-sortIcon field="IncidentDT"></p-sortIcon></th>
				<th pSortableColumn="SchoolIncidentTypeDesc">Incident Type<p-sortIcon field="SchoolIncidentTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="Comment">Comment<p-sortIcon field="Comment"></p-sortIcon></th>
				<th pSortableColumn="AdminName">Created By<p-sortIcon field="AdminName"></p-sortIcon></th>
				<!-- <th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th> -->
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-SchoolIncident>
			<tr [pSelectableRow]="SchoolIncident" (dblclick)="onRowDblClick(SchoolIncident)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ SchoolIncident[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
